import { render } from "./NoAccessPage.vue?vue&type=template&id=2c65fad7&scoped=true"
import script from "./NoAccessPage.vue?vue&type=script&lang=js"
export * from "./NoAccessPage.vue?vue&type=script&lang=js"

import "./NoAccessPage.vue?vue&type=style&index=0&id=2c65fad7&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c65fad7"]])

export default __exports__